import React from 'react'
import PropTypes from 'prop-types'

import SummaryTabsHeader from './SummaryTabsHeader'
import JobsTable from './JobsTable'
import InvoicesList from './InvoicesList'

import { connect } from 'react-redux'
import { EditInvoiceDialog } from 'billing/invoices/InvoiceDialog'

class SummarySection extends React.Component {

  static propTypes = {
    style: PropTypes.object,
    teamId: PropTypes.string.isRequired,
    customerId: PropTypes.string.isRequired,
    contactId: PropTypes.string.isRequired,
    dispatch: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedTab: '',
      openInvoice: false
    }
  }

  onTabSelected = (selectedTab) => {
    this.setState({ selectedTab })
  }

  onSelection = (eventId, dateStr) => {
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: 'JOB_SCREEN',
      value: { jobInfo: { id: eventId }, dateStr }
    })
  }

  handleInvoiceViewRequested = selectedInvoice => {
    this.setState({
      openInvoice: true,
      openMode: 'preview',
      selectedInvoice
    })
  }

  handleInvoiceDialogClose = () => {
    this.setState({ openInvoice: false })
  }

  render() {
    const { customerId, contactId, teamId } = this.props
    const { selectedTab } = this.state

    let component = null

    if (selectedTab === 'pastJobs'){
      component = <JobsTable
        style={{ marginTop: 36 }}
        teamId={teamId}
        customerId={customerId}
        contactId={contactId}
        selectedTab={'pastJobs'}
        onSelection={this.onSelection}/>
    } else if (selectedTab === 'futureJobs'){
      component = <JobsTable
        style={{ marginTop: 36 }}
        teamId={teamId}
        customerId={customerId}
        contactId={contactId}
        selectedTab={'futureJobs'}
        onSelection={this.onSelection}/>
    } else if (selectedTab === 'invoices'){
      component = <InvoicesList
        style={{ marginTop: 36 }}
        teamId={teamId}
        filters={{ customerId, contactId }}
        onInvoiceViewRequested={this.handleInvoiceViewRequested} />
    }

    return (
      <div style={styles.container}>
        <SummaryTabsHeader
          style={styles.tabHeader}
          onTabSelected={this.onTabSelected}/>
        { component }
        <EditInvoiceDialog
          open={this.state.openInvoice}
          teamId={this.props.teamId}
          mode='preview'
          disableActions={true}
          invoice={this.state.selectedInvoice}
          onCloseRequested={this.handleInvoiceDialogClose} />
      </div>
    )
  }

}

export default connect()(SummarySection)

const styles = {
  container: {
    height: 400
  },
  tabHeader: {
    marginTop: 48
  }
}



// WEBPACK FOOTER //
// ./src/customer/CustomerSummary/SummarySection.js